import {isCursorInInlineSpace} from "../state.js";
import {simplePut} from "./changes.js";

export function insertEmoji(emojiName) {
  return ({state, dispatch}) => {
    if (emojiName.length === 0) {
      return;
    }
    if (canInsertEmoji(state)) {
      simplePut(state, dispatch, emojiPadding(state) + ':' + emojiName + ':');
    }
  };
}

function emojiPadding(state) {
  if (/\w/.test(characterBeforeCursor(state))) {
    return ' ';
  }
  return '';
}

function characterBeforeCursor(state) {
  const position = state.selection.main.anchor;
  return state.doc.sliceString(position - 1, position);
}

export function canInsertEmoji(state) {
  return isCursorInInlineSpace(state);
}
